import React from 'react';
import {Icon, Popup} from 'semantic-ui-react';

export const renderInformationPopup = (ordersState, ordersColors) => {
  return (
    <Popup inverted position='bottom left' on='click' flowing
      trigger={<Icon link name='info circle' color='blue' size='large' />}>
      <Popup.Content>
        <h4><strong>DEFINICIÓN DE COLORES</strong></h4>
        <div style={{'border': '1px solid white', 'margin-top': '5px', 'padding': '5px'}}>
          <strong>Proceso Facturación {ordersState.invoicingTypeSelected === 'N' ? 'Normal' : 'Anticipada'}</strong>
          <ul style={{'listStyleType': 'none', 'padding': 0, 'margin': 0}}>
            {ordersState.invoicingTypeSelected === 'N' &&
              <li><Icon name='circle' size='large' style={{'color': 'white'}} />La orden aún no ha sido creada</li>}
            <li><Icon name='circle' size='large' style={{'color': '#fbcfcf'}} />
              El combo no tiene tareas asignadas y no se puede generar una orden</li>
            <li><Icon name='circle' size='large' style={{'color': ordersColors[31].background}} />
              {ordersState.invoicingTypeSelected === 'N' ? 'La orden aún no ha sido creada' :
                'Orden facturada anticipadamente disponible para trabajar'}</li>
            <li><Icon name='circle' size='large' style={{'color': '#d3bcf9'}} />
              La orden ya tiene técnicos asignados</li>
            <li><Icon name='circle' size='large' color='blue'
              style={{'color': ordersColors[63].background}} />En espera de lavada</li>
            <li><Icon name='circle' size='large' color='green'
              style={{'color': ordersColors[80].background}} />La orden ha sido cerrada</li>
            <li><Icon name='circle' size='large' style={{'color': ordersColors[85].color}} />
              La orden ha sido cancelada o cerrada no facturable</li>
          </ul>
        </div>
        {ordersState.invoicingTypeSelected === 'S' &&
          <div style={{'border': '1px solid white', 'margin-top': '5px', 'padding': '5px'}}>
            <strong>Pedido físico de accesorios</strong>
            <ul style={{'listStyleType': 'none', 'padding': 0, 'margin': 0}}>
              <li><Icon name='box' size='large' color='grey' />
                Pedido sin solicitar</li>
              <li><Icon name='box' size='large' color='yellow' />
                Pedido pendiente</li>
              <li><Icon name='box' size='large' color='green' />
                Pedido entregado</li>
            </ul>
          </div>
        }
      </Popup.Content>
    </Popup>
  );
};
